export const TOAST_DURATION_IN_MS = 8000;
export const KEYCODE_ENTER = 'enter';

export const BREAKPOINTS = {
  xs: 0,
  md: 672,
  lg: 1024
};
